import React, { Component } from 'react';
import { connect } from 'react-redux';
import ConfirmActionModal from '../ConfirmActionModal';
import {
  Row,
  Col,
  Card,
  CardHeader,
  CardTitle,
  CardBody,
  Button,
  Nav,
  NavLink,
  NavItem,
} from 'reactstrap';
import classnames from 'classnames';

import { callApi, formatAmount } from '../../utils';
import { showError } from '../../actions/notificationActions';

import { openUserModal } from '../../actions/modalActions';

import ClickToCopy from '../ClickToCopy';
import SettlementsTab from './SettlementsTab';
import { Route, Switch } from 'react-router-dom';

class Detail extends Component {
  state = {
    gateway: {},
    meta: {},

    loading: true,
    activeTab: '1',
    toggle: null,
    rows: [],
    page: 1,
    pages: 1,
    limit: 10,
  };

  componentWillMount() {
    this.loadView();
  }

  startLoad = () => this.setState({ loading: true });
  stopLoad = () => this.setState({ loading: false });

  scrollToTop = () =>
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 200);

  loadView = (e) => {
    const id = this.props.match.params.id;

    this.startLoad();
    callApi(`/payment/gateways/${id}`)
      .then(({ data = {}, meta = {} }) => {
        this.setState({ gateway: data });
        this.scrollToTop();
      })
      .catch((err) => {
        this.props.dispatch(showError(err));
      })
      .finally(() => {
        this.stopLoad();
      });
  };

  getSettlements = (params) => {
    const id = this.props.match.params.id;

    this.startLoad();
    callApi(`/settlement/${id}`, params)
      .then(({ data = {}, meta = {} }) => {
        this.setState({ rows: data, meta });
        this.scrollToTop();
      })
      .catch((err) => {
        this.props.dispatch(showError(err));
      })
      .finally(() => {
        this.stopLoad();
      });
  };

  setPage = (page) => {
    if (page) {
      this.setState({ page }, () => {
        this.loadView();
      });
    }
  };

  opentUser = (id) => {
    this.props.dispatch(openUserModal(id));
  };

  setInput = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  render() {
    let { gateway, meta } = this.state;

    // const toggle = (tab) => {
    //   this.setState({ activeTab: tab });
    // };

    const { history, match, location } = this.props;

    const id = match.params.id;

    return (
      <div className="content">
        <ConfirmActionModal />
        <Row>
          <Col xs={12} md={12}>
            <Card>
              <CardHeader className="ml-2">
                <div className="d-flex justify-content-between align-contents-center">
                  <div>
                    <CardTitle>{gateway.name || 'Loading...'}</CardTitle>
                    <p className="category">Payment Gateway</p>
                  </div>
                  <div>
                    <Button
                      onClick={this.confirmRegenerate}
                      disabled={!meta.canRegenerate}
                      color="primary"
                    >
                      Deactivate
                    </Button>
                  </div>
                </div>
              </CardHeader>

              <CardBody>
                <div>
                  <Nav tabs>
                    <NavItem>
                      <NavLink
                        style={{ color: 'black' }}
                        href="#"
                        className={classnames({
                          active: location.pathname === `${match.url}`,
                        })}
                        onClick={() => {
                          history.push(`${match.url}`);
                        }}
                      >
                        General
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        style={{ color: 'black' }}
                        href="#"
                        className={classnames({
                          active:
                            location.pathname === `${match.url}/settlements`,
                        })}
                        onClick={() => {
                          history.push(`${match.url}/settlements`);
                        }}
                      >
                        Settlements
                      </NavLink>
                    </NavItem>
                  </Nav>
                  <br />
                  <div>
                    <Switch>
                      <Route exact path={`${match.path}`}>
                        <GeneralTab gateway={gateway} />
                      </Route>
                      <Route path={`${match.path}/settlements`}>
                        <SettlementsTab id={id} />
                      </Route>
                    </Switch>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

function GeneralTab({ gateway }) {
  return (
    <Row>
      <Col sm="6">
        <Card className="card-chart">
          <CardHeader>
            <CardTitle className="mt-0">Gateway</CardTitle>
          </CardHeader>
          <CardBody>
            <div className="d-flex mb-3 justify-content-between">
              <div>
                <span className="text-secondary">Order ID</span>
              </div>
              <div> {gateway.order_id} </div>
            </div>
            <div className="d-flex mb-3 justify-content-between">
              <div>
                <span className="text-secondary">Name</span>
              </div>
              <div> {gateway.name} </div>
            </div>
            <div className="d-flex mb-3 justify-content-between">
              <div>
                <span className="text-secondary">Phone</span>
              </div>
              <span>
                <span className="cursor-pointer blue-text" onClick={() => {}}>
                  <strong>{gateway.phone}</strong>{' '}
                </span>
                <ClickToCopy value={gateway.phone} />
              </span>
            </div>
            <div className="d-flex mb-3 justify-content-between">
              <div>
                <span className="text-secondary">DisCo</span>
              </div>
              <div> {gateway.disco_code} </div>
            </div>
            <div className="d-flex mb-3 justify-content-between">
              <div>
                <span className="text-secondary">Payment Method</span>
              </div>
              <div> {gateway.payment_type} </div>
            </div>
            <div className="d-flex mb-3 justify-content-between">
              <div>
                <span className="text-secondary">Amount</span>
              </div>
              {gateway.amount && <div> {formatAmount(gateway.amount)} </div>}
            </div>
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
}

export default connect()(Detail);
